'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        // set default data
        return {
            recipes: null,
            activeTab: 0,
            winningRecipes: [],
            currentPage: 0,
            itemsPerPage: 1,
            resultCount: 3,
            totalPages: 3
        };
    },
    ready: function ready() {
        ga('send', 'event', 'Game ended', 'click', 'Game ended', 1);
        this.$http.get('assets/js/recipes.json').then(function (recipes) {
            this.$set('recipes', recipes.data.recipes);
            for (var i in this.recipes) {
                // TODO: make winning recipes dynamic
                // get the winning recipes and push to new array
                switch (this.recipes[i].id) {
                    case this.$route.params.one:
                        this.winningRecipes.push(this.recipes[i]);
                        break;
                    case this.$route.params.two:
                        this.winningRecipes.push(this.recipes[i]);
                        break;
                    case this.$route.params.three:
                        this.winningRecipes.push(this.recipes[i]);
                        break;
                }
            }
        });
    },

    methods: {
        /**
         * Set the result container to the correct Winning Recipe
         * @param event
         * @param index
         * @returns {*}
         */
        tabber: function tabber(event, index) {
            var active = document.querySelectorAll('.matcher__result--active');

            Array.prototype.forEach.call(active, function (el, i) {
                el.classList.remove('matcher__result--active');
            });

            event.target.classList.add('matcher__result--active');
            return this.activeTab = index;
        },

        /**
         * set the Pagination to the clicked Page
         * @param pageNumber
         */
        setPage: function setPage(pageNumber) {
            this.currentPage = pageNumber;
        }
    },
    filters: {
        /**
         * Filter the recipes with pagination
         * @param list
         * @returns {string|Array|*|ArrayBuffer|Blob|Array.<T>}
         */
        paginate: function paginate(list) {
            this.resultCount = list.length;
            if (this.currentPage >= this.totalPages) {
                this.currentPage = this.totalPages;
            }
            var index = this.currentPage * this.itemsPerPage;
            return list.slice(index, index + this.itemsPerPage);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"container\">\n    <p class=\"h1 text-center text--alternative section__title matcher__resultTitle\">\n        <span class=\"matcher__pagesIntro\">Dein Match</span>\n        <span v-for=\"pageNumber in totalPages\">\n            <span @click=\"setPage(pageNumber)\" class=\"matcher__result\" :class=\"{'matcher__result--active': currentPage === pageNumber}\">#{{ pageNumber + 1}}</span>\n        </span>\n    </p>\n    \n    <div class=\"matcher__tabContainer\">\n        <div class=\"matcher__tabResult resultContainer\" v-for=\"winner in winningRecipes | paginate\" transition=\"stagger\">\n            <div class=\"resultContainer__text\">\n                <div class=\"top\">\n                    <h4 class=\"text--alternative winner__headline\">{{ winner.details.headline }}</h4>\n                    <div class=\"resultContainer__description\">\n                        {{ winner.details.text }}\n                    </div>\n\n                        <figure class=\"candidate__imageWrapper\">\n                            <div class=\"intrinsic\" v-if=\"winner.image\">\n                                <img data-src=\"assets/images/htmlimages/candidates/{{ winner.image }}\" src=\"http://www.arabianbusiness.com/skins/ab.main/gfx/loading_spinner.gif\" v-spinner=\"['image', 'assets/images/htmlimages/candidates/' + winner.image]\" alt=\"Candidate Image\" class=\"lazyload candidate__image intrinsic__item\">\n\n                            </div>\n                            <div class=\"videoFrame\" v-else=\"\">\n                                <div class=\"videoWrapper\">\n                                    <img src=\"http://www.arabianbusiness.com/skins/ab.main/gfx/loading_spinner.gif\" class=\"intrinsic__item\">\n                                    <iframe width=\"960\" height=\"720\" v-bind:src=\"winner.video\" frameborder=\"0\" allowfullscreen=\"\" v-spinner=\"['iframe', winner.video]\"></iframe>\n                                </div>\n                            </div>\n                        </figure>\n\n\n                </div>\n                <div class=\"resultContainer__buttons\">\n                    <a onclick=\"ga('send', 'event', 'Rezept Link', 'click', '{{ winner.details.headline }}', 1);\" target=\"_blank\" href=\"{{ winner.link }}\" class=\"button button--ghost button--medium\">\n                        Zum Rezept\n                    </a>\n                    <a target=\"_blank\" onclick=\"ga('send', 'event', 'Facebook Share', 'click', '{{ winner.details.headline }}', 1);\" href=\"https://www.facebook.com/sharer/sharer.php?u=http://florette.de/speed-dating/share/{{ winner.id }}\" class=\"button button--ghost button--medium\">Teilen</a>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6b50562f", module.exports)
  } else {
    hotAPI.update("_v-6b50562f", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}